import React, { useEffect } from "react";
import KayarOtomat from "../Components/urunlerimiz/KayarOtomat";
import useSEO from "../seo/useSEO";

function KayarOtomatPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useSEO({
    title: "CNC Kayar Otomat ve Talaşlı İmalat | Aypin Otomat",
    description:
      "Aypin Otomat, Bursa Nilüfer'de CNC kayar otomat ve hassas talaşlı imalat çözümleri sunar. Özel üretim parçalar ve üretim hizmetlerimizi inceleyin.",
    path: "/cnc/kayar-otomat",

    breadcrumbs: [
      {
        name: "Ana Sayfa",
        path: "/",
      },
      {
        name: "Ürünlerimiz",
        path: "/urunlerimiz",
      },
      {
        name: "CNC Kayar Otomat",
        path: "/cnc/kayar-otomat",
      },
    ],
  });

  return <KayarOtomat />;
}

export default KayarOtomatPage;